import '@amplemarket/amplie/dist/esm/index.css';
import { createRoot } from 'react-dom/client';
import Extension from 'extension/Extension';
import GlobalProvider from 'shared/wrappers/GlobalProvider';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('react-amplemarket-hook-wrapper');

  if (node) {
    const data = JSON.parse(node.getAttribute('data'));
    const root = createRoot(node);

    root.render(
      <GlobalProvider>
        <Extension data={data} />
      </GlobalProvider>
    );
  }
});
